import educationInfoReducer from "./reducers";
export { default as educationInfoTypes } from "./types";
export { default as educationInfoOperations } from "./operations";
export default educationInfoReducer;
